import { Action } from '../../../common/actions/core/action';
import ActionDispatcherService from '../../../common/actions/core/action-dispatcher.service';
import { ActionHandler } from '../../../common/actions/core/action-handler';
import { OtpAction } from './otp-dialog.action';
import NotificationService from '../../../common/services/notification/notification.service';
import NoAuthService from '../../services/noauth.service';

/* @ngInject */
export default class OtpDialogController implements ActionHandler {
  public time: string;
  private dialogElement;
  private msisdn;
  private formatededMsisdn;
  private timer: any = null;
  private minutes = 2;
  private seconds = 0;
  private resend = false;
  private smsCode = [-1, -1, -1, -1, -1, -1];

  protected approved: () => any;

  constructor(
    private $element,
    private $translate,
    private $interval,
    private noAuthService: NoAuthService,
    private actionDispatcher: ActionDispatcherService,
    private notificationService: NotificationService
  ) {
    this.actionDispatcher.register(this);
  }

  public $postLink() {
    this.dialogElement = this.$element
      .find('#otp-dialog')
      .remodal();
  }

  public $onDestroy() {
    this.actionDispatcher.unregister(this);
    this.dialogElement.destroy();
  }

  public handle(action: Action) {
    if (action instanceof OtpAction) {
      this.approved = action.approved;
      this.msisdn = action.msisdn;
      this.initiate();
    }
  }

  private initiate() {
    this.formatededMsisdn = "0" + this.msisdn.substring(0, 3) + " " + this.msisdn.substring(3, 6) + " " + this.msisdn.substring(6, 8) + " **";
    this.noAuthService.getTimeout().then(timeout => {
      this.minutes = Math.floor(timeout / 60);
      this.seconds = timeout % 60;
    });
    this.time = '0' + this.minutes + ':' + (this.seconds > 9 ? this.seconds : '0' + this.seconds);
    this.resend = false;
    this.openDialog();
    document.getElementById("digit0").focus();
    var elem = document.getElementById("otp-code");
    if (elem.getAttribute('listener') !== 'true') {
      document.getElementById("otp-code").setAttribute('listener', 'true');
      document.querySelector(".otp-code").addEventListener("input", (e) => this.handleInputEvent(e));
      document.querySelector(".otp-code").addEventListener("keydown", (e) => this.handleKeydownEvent(e));
    }
    this.startTimer();
  }

  public onClick() {
    if (this.checkCode()) {
      this.noAuthService.validateOTP(this.msisdn, this.smsCode.join("")).then(result => {
        if (result) {
          this.approved();
          this.close();
        } else {
          this.warning('noAuth.otp.code.error');
          this.resetCode();
        }
      });
    } else {
      this.warning('noAuth.otp.code.empty');
    }
  }

  public onResend() {
    this.noAuthService.sendOTP(this.msisdn).then(result => {
      if (result) {
        this.resend = false;
        this.resetTimer();
        this.startTimer();
        this.resetCode();
      } else {
        this.$interval.cancel(this.timer);
        this.warning('noAuth.otp.code.resendError');
      }
    });
  }

  private openDialog() {
    this.dialogElement.open();
  }

  private close() {
    this.dialogElement.close();
    this.resetTimer();
    this.resetCode();
  }

  private warning(text: string) {
    this.$translate(text).then(value => {
      this.notificationService.showNotification({
        text: value,
        type: 'warning'
      });
    });
  }

  protected resetTimer() {
    if (angular.isDefined(this.timer)) {
      this.$interval.cancel(this.timer);
    }
    this.time = '02:00';
    this.minutes = 2;
    this.seconds = 0;
  }

  private startTimer() {
    this.timer = this.$interval(() => {
      if (this.seconds > 0) {
        this.seconds--;
      } else if (this.minutes > 0) {
        this.minutes--;
        this.seconds = 59;
      } else {
        this.resend = true;
        return;
      }
      this.time = '0' + this.minutes + ':' + (this.seconds > 9 ? this.seconds : '0' + this.seconds);
    }, 1000);
  }

  public handleInputEvent(e: any) {
    e.preventDefault();
    if (e.inputType === 'deleteContentBackward') {
      return;
    }
    var input = e.data === null || e.data === undefined ? e.srcElement.value : e.data;
    var digit = parseInt(e.srcElement.id.charAt(5));

    if (input.length === 1 && !isNaN(Number(input))) {
      e.srcElement.classList.remove("otp-input-invalid");
      (document.getElementById("digit" + digit) as HTMLInputElement).value = input;
      this.smsCode[digit] = input;

      if (digit < 5) {
        document.getElementById("digit" + (digit + 1)).focus();
      }
    } else if (input.length < 7 && !isNaN(Number(input))) {
      var j = 0;
      for (let i = digit; i < Math.min(input.length + digit, 6); i++) {
        (document.getElementById("digit" + i) as HTMLInputElement).value = input[j];
        this.smsCode[i] = Number(input[j]);
        j++;
      }
      document.getElementById("digit" + (input.length === 6 ? 5 : input.length)).focus();
    } else {
      (document.getElementById("digit" + digit) as HTMLInputElement).value = !isNaN(Number(input[0])) ? input[0] : "";
    }
  }

  public handleKeydownEvent(e: any) {
    var digit = parseInt(document.activeElement.id.charAt(5));
    if (e.key === "ArrowRight") {
      if (digit < 5) {
        document.getElementById("digit" + (digit + 1)).focus();
      }
    } else if (e.key === "ArrowLeft") {
      if (digit > 0) {
        document.getElementById("digit" + (digit - 1)).focus();
      }
    } else if (e.key === "Backspace" || e.key === "Delete") {
      if ((document.getElementById("digit" + digit) as HTMLInputElement).value !== "") {
        this.smsCode[digit] = -1;
        (document.getElementById("digit" + digit) as HTMLInputElement).value = "";
      } else {
        if (digit > 0) {
          document.getElementById("digit" + (digit - 1)).focus();
        }
      }
    } else if (e.key === "Enter") {
      if (this.smsCode.indexOf(-1) >= 0) {
        this.highlightEmptyBoxes();
      } else {
        if (!this.resend) {
          this.onClick();
        }
      }
    }
  }

  private checkCode(): boolean {
    if (this.smsCode.indexOf(-1) >= 0) {
      this.highlightEmptyBoxes();
      return false;
    }
    return true;
  }

  private resetCode() {
    this.smsCode = [-1, -1, -1, -1, -1, -1];
    for (let i = 0; i < 6; i++) {
      var elem = document.getElementById("digit" + i) as HTMLInputElement;
      elem.classList.remove("otp-input-invalid");
      elem.value = "";
    }
    document.getElementById("digit0").focus();
  }

  private highlightEmptyBoxes() {
    document.getElementById("digit" + this.smsCode.indexOf(-1)).focus();
    for (let i = 0; i < 6; i++) {
      if (this.smsCode[i] === -1) {
        var elem = document.getElementById("digit" + i) as HTMLInputElement;
        elem.classList.add("otp-input-invalid");
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/no-auth/components/otp-dialog/otp-dialog.controller.ts